import unwrapPromotions from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPromotions/functions/unwrapPromotions'

export default function getSectionMenuPromotionsCount(
  promotions: unknown,
  promotionsCount?: number,
): number | undefined {
  const count = Math.max(
    unwrapPromotions(promotions).length,
    promotionsCount ?? 0,
  )

  return count > 0 ? count : undefined
}
